import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
const COUNTDOWN_MINUTES = 15;
function CountdownTimer() {
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_MINUTES * 60);
  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 font-mono" data-id="element-61">
      {[{
      label: 'MIN',
      value: pad(minutes)
    }, {
      label: 'SEG',
      value: pad(seconds)
    }].map((unit, i) => <Fragment key={unit.label} data-id="element-62">
          <div className="flex flex-col items-center bg-gradient-to-br from-rose-600 to-pink-600 text-white rounded-xl px-4 py-2.5 min-w-[64px] shadow-lg" data-id="element-63">
            <span className="text-3xl font-black tabular-nums leading-none" data-id="element-64">
              {unit.value}
            </span>
            <span className="text-[9px] font-bold tracking-widest text-rose-100 mt-1" data-id="element-65">
              {unit.label}
            </span>
          </div>
          {i < 1 && <span className="text-rose-600 font-black text-2xl" data-id="element-66">:</span>}
        </Fragment>)}
    </div>;
}
const DIAGNOSIS = [{
  icon: '✅',
  label: 'Viabilidad',
  value: 'ALTA',
  text: 'Las minidonas tienen el costo de producción más bajo del mercado.',
  accent: 'from-emerald-500 to-emerald-600',
  bg: 'bg-emerald-50',
  border: 'border-emerald-200',
  badge: 'bg-emerald-100 text-emerald-700'
}, {
  icon: '🎯',
  label: 'Nicho Recomendado',
  value: 'Torres & Tortas Temáticas',
  text: 'La tendencia más buscada del 2026 para cumpleaños y eventos.',
  accent: 'from-rose-500 to-pink-500',
  bg: 'bg-rose-50',
  border: 'border-rose-200',
  badge: 'bg-rose-100 text-rose-700'
}, {
  icon: '📈',
  label: 'Plan de Acción',
  value: 'Hoja de ruta paso a paso',
  text: 'Para que no pierdas tiempo ni plata probando sola.',
  accent: 'from-amber-500 to-orange-500',
  bg: 'bg-amber-50',
  border: 'border-amber-200',
  badge: 'bg-amber-100 text-amber-800'
}];
const TOMOS = [{
  num: '1',
  title: 'El ADN de la Masa',
  sub: 'Recetas profesionales + versión Sin TACC'
}, {
  num: '2',
  title: 'Master de Glaseados, Colores y Toppings',
  sub: 'Acabados que venden a primera vista'
}, {
  num: '3',
  title: 'Minidonas Saladas: El Sabor Argento',
  sub: 'Para picadas y eventos gourmet'
}, {
  num: '4',
  title: 'Minidonas Fritas Perfectas',
  sub: 'Textura, dorado y conservación'
}, {
  num: '5',
  title: 'Packaging y Presentación Premium',
  sub: 'Que tus clientes saquen foto antes de probar'
}, {
  num: '6',
  title: 'Tu Negocio en Pesos',
  sub: 'Costos, precios, clientes y redes'
}];
const BONOS = [{
  tag: 'BONO 1',
  title: 'Kit de Arranque Rápido',
  sub: 'Vendé en 7 días, paso a paso',
  highlight: false
}, {
  tag: 'BONO 2',
  title: 'Calendario Express de Contenido',
  sub: '30 ideas listas para Instagram',
  highlight: false
}, {
  tag: 'BONO 3',
  title: 'Banco de Nombres y Frases para Vender',
  sub: 'Copy que convierte sin esfuerzo',
  highlight: false
}, {
  tag: '🔥 BONO 4 · NUEVO',
  title: 'Tortas y Torres Temáticas con Minidonas',
  sub: '¡La gran TENDENCIA 2024!',
  highlight: true
}];
export function ResultsScreen() {
  return <div className="flex flex-col min-h-screen bg-gradient-to-b from-rose-50 via-[#fff7ed] to-amber-50 text-rose-950 pb-12 overflow-hidden" data-id="element-67">
      {/* ============ SECTION 1 — Resultado ============ */}
      <div className="relative bg-gradient-to-br from-rose-500 via-pink-500 to-rose-600 text-white pt-12 pb-16 px-6 text-center overflow-hidden" data-id="element-68">
        {/* Decorative donuts */}
        <div className="absolute top-4 left-4 text-4xl opacity-40 animate-pulse" data-id="element-69">
          🍩
        </div>
        <div className="absolute top-8 right-6 text-3xl opacity-40" data-id="element-70">🧁</div>
        <div className="absolute bottom-6 left-8 text-2xl opacity-30" data-id="element-71">✨</div>
        <div className="absolute bottom-10 right-4 text-3xl opacity-30" data-id="element-72">🎂</div>

        <motion.div initial={{
        scale: 0,
        rotate: -10
      }} animate={{
        scale: 1,
        rotate: 0
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 15
      }} className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full text-white text-[10px] font-extrabold tracking-[0.18em] uppercase mb-5" data-id="element-73">
          🎉 Análisis Completado
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.15
      }} className="font-display font-black text-[28px] leading-[1.1] mb-3 tracking-tight" data-id="element-74">
          ¡FELICITACIONES! Tenés un{' '}
          <span className="bg-gradient-to-r from-amber-200 via-yellow-100 to-amber-300 bg-clip-text text-transparent" data-id="element-75">
            Perfil Emprendedor de ALTO POTENCIAL
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-[14px] text-rose-50/95 font-medium leading-relaxed max-w-sm mx-auto" data-id="element-76">
          Según tus respuestas, tenés todo lo necesario para construir un
          negocio rentable con minidonas. Tu perfil indica que podés recuperar
          tu inversión{' '}
          <span className="font-extrabold text-white underline decoration-amber-300 decoration-2 underline-offset-2" data-id="element-77">
            con tu primer pedido
          </span>
          .
        </motion.p>
      </div>

      <div className="max-w-md mx-auto w-full px-5 -mt-10 relative z-10 flex flex-col" data-id="element-78">
        {/* ============ SECTION 2 — Diagnóstico Visual ============ */}
        <div className="grid gap-3 mb-8" data-id="element-79">
          {DIAGNOSIS.map((d, i) => <motion.div key={d.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className={`${d.bg} ${d.border} border-2 rounded-2xl p-4 shadow-sm flex items-start gap-3`} data-id="element-80">
              <div className={`flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br ${d.accent} flex items-center justify-center text-2xl shadow-md`} data-id="element-81">
                {d.icon}
              </div>
              <div className="flex-grow min-w-0" data-id="element-82">
                <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-83">
                  <span className="text-[10px] font-extrabold tracking-widest uppercase text-rose-900/60" data-id="element-84">
                    {d.label}:
                  </span>
                  <span className={`${d.badge} text-[10px] font-extrabold px-2 py-0.5 rounded-full uppercase tracking-wide`} data-id="element-85">
                    {d.value}
                  </span>
                </div>
                <p className="text-[13px] text-rose-950/85 font-medium leading-snug" data-id="element-86">
                  {d.text}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* ============ SECTION 3 — Producto ============ */}
        <div className="text-center mb-5" data-id="element-87">
          <span className="inline-block text-[10px] font-extrabold tracking-[0.2em] uppercase text-rose-700 bg-rose-100 px-3 py-1 rounded-full mb-3" data-id="element-88">
            La solución exacta para tu perfil
          </span>
          <h3 className="font-display font-black text-[28px] leading-[1.05] text-rose-950 tracking-tight mb-2" data-id="element-89">
            MEGA PACK EMPRENDE{' '}
            <span className="bg-gradient-to-r from-rose-600 via-pink-600 to-amber-500 bg-clip-text text-transparent" data-id="element-90">
              MINIDONAS 360
            </span>{' '}
            🍩
          </h3>
          <p className="text-sm text-rose-900/75 font-medium leading-relaxed px-2" data-id="element-91">
            El pack digital más completo de Argentina para emprender con
            minidonas desde cero.
          </p>
        </div>

        {/* Tomos card */}
        <div className="bg-white rounded-2xl p-5 mb-3 shadow-lg border border-rose-100" data-id="element-92">
          <div className="flex items-center gap-2 mb-4 pb-3 border-b border-rose-100" data-id="element-93">
            <span className="text-xl" data-id="element-94">📚</span>
            <span className="text-[11px] font-extrabold tracking-widest uppercase text-rose-700" data-id="element-95">
              6 Tomos Profesionales
            </span>
          </div>
          <ul className="flex flex-col gap-3" data-id="element-96">
            {TOMOS.map(t => <li key={t.num} className="flex items-start gap-3" data-id="element-97">
                <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-gradient-to-br from-rose-500 to-pink-500 text-white font-black flex items-center justify-center text-sm shadow-md" data-id="element-98">
                  {t.num}
                </div>
                <div className="flex-grow min-w-0 pt-0.5" data-id="element-99">
                  <p className="text-[14px] font-extrabold text-rose-950 leading-tight" data-id="element-100">
                    {t.title}
                  </p>
                  <p className="text-[12px] text-rose-900/65 font-medium mt-0.5" data-id="element-101">
                    {t.sub}
                  </p>
                </div>
                <span className="flex-shrink-0 text-emerald-500 mt-1.5" data-id="element-102">✓</span>
              </li>)}
          </ul>
        </div>

        {/* Bonos card */}
        <div className="bg-gradient-to-br from-amber-50 to-rose-50 rounded-2xl p-5 mb-8 shadow-lg border-2 border-amber-200" data-id="element-103">
          <div className="flex items-center gap-2 mb-4 pb-3 border-b border-amber-200" data-id="element-104">
            <span className="text-xl" data-id="element-105">🎁</span>
            <span className="text-[11px] font-extrabold tracking-widest uppercase text-amber-700" data-id="element-106">
              + 4 Bonos Exclusivos
            </span>
          </div>
          <ul className="flex flex-col gap-3" data-id="element-107">
            {BONOS.map(b => <li key={b.tag} className={`flex items-start gap-3 ${b.highlight ? 'bg-white rounded-xl p-3 -mx-1 border-2 border-amber-300 shadow-sm' : ''}`} data-id="element-108">
                <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-gradient-to-br from-amber-400 to-orange-500 text-white flex items-center justify-center text-base shadow-md" data-id="element-109">
                  🎁
                </div>
                <div className="flex-grow min-w-0 pt-0.5" data-id="element-110">
                  <p className={`text-[9px] font-black tracking-widest uppercase mb-0.5 ${b.highlight ? 'text-amber-700' : 'text-amber-700/80'}`} data-id="element-111">
                    {b.tag}
                  </p>
                  <p className="text-[14px] font-extrabold text-rose-950 leading-tight" data-id="element-112">
                    {b.title}
                  </p>
                  <p className="text-[12px] text-rose-900/65 font-medium mt-0.5" data-id="element-113">
                    {b.sub}
                  </p>
                </div>
              </li>)}
          </ul>
        </div>

        {/* ============ SECTION 4 — Oferta + Countdown ============ */}
        <div className="relative mb-6" data-id="element-114">
          {/* Glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-rose-400 via-pink-400 to-amber-400 rounded-3xl blur-md opacity-60" data-id="element-115" />

          <div className="relative bg-white rounded-3xl pt-12 pb-6 px-6 shadow-2xl border-2 border-rose-300" data-id="element-116">
            {/* Top banner */}
            <div className="absolute -top-4 left-3 right-3 bg-gradient-to-r from-rose-500 via-pink-500 to-amber-500 text-white text-[11px] font-extrabold tracking-wider px-4 py-2.5 rounded-xl uppercase shadow-lg flex items-center justify-center gap-2" data-id="element-117">
              <span data-id="element-118">🔓</span>
              <span data-id="element-119">Descuento Exclusivo Desbloqueado</span>
              <span data-id="element-120">🔓</span>
            </div>

            <div className="text-center" data-id="element-121">
              <p className="text-[12px] text-rose-900/75 font-semibold mb-3 leading-snug" data-id="element-122">
                Por haber completado el test, desbloqueaste un descuento
                exclusivo
              </p>

              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-123">
                <span className="text-rose-900/40 text-lg font-bold line-through" data-id="element-124">
                  $39.990
                </span>
                <span className="bg-rose-100 text-rose-700 text-[10px] font-black px-2 py-0.5 rounded-md uppercase tracking-wider" data-id="element-125">
                  -50% OFF
                </span>
              </div>
              <p className="text-[12px] font-extrabold tracking-widest text-rose-600 uppercase mb-1" data-id="element-126">
                HOY SOLO
              </p>
              <p className="font-display text-[56px] font-black text-rose-950 tracking-tight leading-none" data-id="element-127">
                $19.990
              </p>
              <p className="text-sm text-rose-700 font-bold mt-1 mb-5" data-id="element-128">
                ARS · Pago único
              </p>

              {/* Countdown */}
              <div className="bg-gradient-to-br from-rose-50 to-amber-50 rounded-2xl p-4 border-2 border-rose-200" data-id="element-129">
                <p className="text-[11px] font-extrabold tracking-widest text-rose-700 uppercase mb-3 flex items-center justify-center gap-1.5" data-id="element-130">
                  <span className="animate-pulse" data-id="element-131">⏰</span>
                  Esta oferta vence en:
                </p>
                <CountdownTimer data-id="element-132" />
              </div>
            </div>
          </div>
        </div>

        {/* ============ SECTION 5 — Main CTA ============ */}
        <motion.a href="https://pay.hotmart.com/M105893566L?utm_source={{site_source_name}}&utm_medium=paid_social&utm_campaign={{campaign.name}}&utm_content={{ad.name}}&utm_term={{adset.name}}&utm_id={{campaign.id}}&ad_id={{ad.id}}&adset_id={{adset.id}}&placement={{placement}}&site_source={{site_source_name}}&sck=facebookads" target="_blank" rel="noopener noreferrer" whileTap={{
        scale: 0.98
      }} whileHover={{
        y: -2
      }} className="relative w-full bg-gradient-to-r from-rose-500 via-pink-500 to-rose-600 hover:from-rose-600 hover:to-pink-600 text-white font-extrabold text-[16px] py-5 px-5 rounded-2xl shadow-[0_16px_40px_-8px_rgba(244,63,94,0.65)] transition-all flex items-center justify-center gap-2 mb-3 text-center leading-tight overflow-hidden" data-id="element-133">
          {/* Shine */}
          <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12" animate={{
          x: ['-150%', '250%']
        }} transition={{
          duration: 2.2,
          repeat: Infinity,
          ease: 'easeInOut',
          repeatDelay: 0.6
        }} data-id="element-134" />
          <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-135">
            <span data-id="element-136">✅</span>
            <span data-id="element-137">SÍ, QUIERO MI MEGA PACK CON DESCUENTO Y EMPEZAR HOY</span>
          </span>
        </motion.a>

        <p className="text-center text-[11px] text-rose-900/65 font-semibold mb-8" data-id="element-138">
          Acceso inmediato · Pago seguro · Garantía de 7 días
        </p>

        {/* ============ SECTION 6 — Trust / Cierre ============ */}
        <div className="grid grid-cols-3 gap-3 mb-6" data-id="element-139">
          {[{
          icon: '🔒',
          title: 'Pago 100%',
          sub: 'Seguro'
        }, {
          icon: '📲',
          title: 'Acceso',
          sub: 'Inmediato por mail'
        }, {
          icon: '✅',
          title: 'Garantía',
          sub: '7 días'
        }].map(item => <div key={item.title} className="bg-white rounded-xl p-3 border border-rose-100 shadow-sm text-center" data-id="element-140">
              <div className="text-2xl mb-1" data-id="element-141">{item.icon}</div>
              <p className="text-[11px] font-extrabold text-rose-950 leading-tight" data-id="element-142">
                {item.title}
              </p>
              <p className="text-[10px] text-rose-900/60 font-semibold leading-tight mt-0.5" data-id="element-143">
                {item.sub}
              </p>
            </div>)}
        </div>

        <div className="bg-white border border-rose-100 rounded-2xl p-4 text-center shadow-sm" data-id="element-144">
          <p className="text-[13px] text-rose-950 font-semibold leading-relaxed" data-id="element-145">
            ¿Tenés alguna duda? Escribinos a{' '}
            <a href="mailto:atencionrecursohub@gmail.com" className="text-rose-600 font-extrabold underline decoration-rose-300 decoration-2 underline-offset-2" data-id="element-146">
              atencionrecursohub@gmail.com
            </a>{' '}
            o por WhatsApp y te respondemos al instante. 💬
          </p>
        </div>

        <p className="text-center text-[10px] text-rose-900/45 font-semibold mt-6 tracking-wide" data-id="element-147">
          © 2026 RecursoHub · Hecho con 🍩 en Argentina
        </p>
      </div>
    </div>;
}